import React from 'react';
import { tHealthPlanBenefitType } from '@models/HealthPlanBenefit';
import { amountToUsd } from '@utils/currency';
import { CorporateHealthOrderUserRemainingBenefit } from '@models/CorporateHealthOrderUserRemainingBenefit';

const BenefitTableRow = ({
  healthPlanBenefit: { benefitType, description, limitAmount },
  remainingLimitAmount,
}: CorporateHealthOrderUserRemainingBenefit) => {
  return (
    <tr>
      <td className="ps-3">{tHealthPlanBenefitType(benefitType)}</td>
      <td>{description}</td>
      <td>{amountToUsd(limitAmount)}</td>
      <td>{amountToUsd(remainingLimitAmount)}</td>
    </tr>
  );
};

export { BenefitTableRow };
